export const imageVariants = {
    hidden: {
        opacity: 0,
        scale: 0.8,
        transition: {
            duration: 0.8, // Increased duration for a smoother transition
            ease: [0.25, 0.1, 0.25, 1], // Smoother cubic-bezier for more gradual transitions
        },
    },
    visible: {
        opacity: 1,
        scale: 1,
        transition: {
            duration: 0.8, // Increased duration
            ease: [0.25, 0.1, 0.25, 1], // Matching ease with hidden state
        },
    },
};

export const textVariants = {
    hidden: {
        opacity: 0,
        y: 50,
        transition: {
            duration: 1, // Slightly longer for smoother movement
            ease: [0.25, 0.1, 0.25, 1], // Smoother ease function
        },
    },
    visible: {
        opacity: 1,
        y: 0,
        transition: {
            duration: 1, // Matched with hidden state for smooth in and out
            ease: [0.25, 0.1, 0.25, 1],
            delay: 0.3, // Increased delay for smoother appearance
        },
    },
};






export const leftTextVariants = {
    hidden: {
        opacity: 0,
        x: -50,
        transition: {
            duration: 1, // Slightly longer for smoother movement
            ease: [0.25, 0.1, 0.25, 1], // Smoother ease function
        },
    },
    visible: {
        opacity: 1,
        x: 0,
        transition: {
            duration: 1, // Matched with hidden state for smooth in and out
            ease: [0.25, 0.1, 0.25, 1],
            delay: 0.3, // Increased delay for smoother appearance
        },
    },
};


export const containerVariants = {
    hidden: {
        transition: {
            duration: 0.7, // Longer duration for softer hide effect
            ease: [0.25, 0.1, 0.25, 1], // Soft easing
        },
    },
    visible: {
        transition: {
            staggerChildren: 0.4, // More time between child animations for smoothness
            duration: 1.2, // Extended duration
            ease: [0.25, 0.1, 0.25, 1], // Smooth ease function
        },
    },
};

export const corporateContainerVariants = {
    hidden: {
        opacity: 0,
        transition: {
            staggerChildren: 0.3,  // Increased delay for a softer, smoother stagger
            ease: [0.25, 0.1, 0.25, 1], // Smoother easing for the stagger effect
        },
    },
    visible: {
        opacity: 1,
        transition: {
            staggerChildren: 0.3,  // Matches the hidden state for consistency
            ease: [0.25, 0.1, 0.25, 1], // Same smooth easing
        },
    },
};











export const fadeInUp = (delay = 0) => ({
    initial: {
        translateY: -10,
        opacity: 0
    },
    animate: {
        translateY: 0,
        opacity: 1,
        transition: {
            duration: 1,
            delay: delay
        }
    }
})


export const azxc = {
    visible: {
        opacity: 1,
        transition: {
            staggerChildren: 0.3,
            ease: "easeInOut",
            duration: 0.6,
        },
    },
    hidden: {
        opacity: 0,
    },
};

export const bzxc = {
    visible: {
        opacity: 1,
        y: 0,
        transition: {
            duration: 0.8,
            ease: [0.42, 0, 0.58, 1],
        },
    },
    hidden: {
        opacity: 0,
        y: -30,
    },
};



export const variants = {
    container: {
        hidden: { opacity: 0, y: 20 },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                staggerChildren: 0.2,
            },
        },
    },
    item: {
        hidden: { opacity: 0, scale: 0.9 },
        visible: {
            opacity: 1,
            scale: 1,
            transition: {
                duration: 0.5,
                type: 'spring',
                stiffness: 100,
            },
        },
        hover: {
            scale: 1.05,
            boxShadow: '0px 10px 30px rgba(0, 0, 0, 0.2)',
            transition: {
                duration: 0.3,
            },
        },
    },
    image: {
        default: { opacity: 0.5, scale: 1 },
        hover: { opacity: 1, scale: 1.05 },
    },
    arrow: {
        default: { opacity: 0.25, translateX: 0, translateY: 0 },
        hover: { opacity: 1, translateX: 10, translateY: 10 },
    },
    text: {
        default: { opacity: 0.5 },
        hover: { opacity: 1 },
    },


    list: {

        visible: index => ({
            opacity: [0, 1],
            scale: [0.9, 1.05, 1],
            translateY: [20, 0],

            transition: {
                delay: index * 0.1,
                duration: 1,
                ease: "easeInOut",
            },
        }),
        hidden: {
            opacity: 0,
            scale: 0.9,
            translateY: 20,


        },
    }


};

